import { SET_ORDER } from '../actions/actionTypes';

import PickupOrder from '../../models/PickupOrder';
import{ PO_SCHEMA } from '../../utils/pickupOrder';

const initialState: PickupOrder = PO_SCHEMA;

export const orderReducer = (state: PickupOrder = initialState, action: any) => {

  switch (action.type) {
      
    case SET_ORDER:
      return  { ...action.data }
    default:
      return state;
  }
};